// extracted by mini-css-extract-plugin
module.exports = {"paginado":"paginado_paginado__1YIZB","li":"paginado_li__2cO0c"};